import { render, staticRenderFns } from "./ProxyTester.vue?vue&type=template&id=60e19604&scoped=true"
import script from "./ProxyTester.vue?vue&type=script&lang=js"
export * from "./ProxyTester.vue?vue&type=script&lang=js"
import style0 from "./ProxyTester.vue?vue&type=style&index=0&id=60e19604&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e19604",
  null
  
)

export default component.exports